// extracted by mini-css-extract-plugin
export var arrows = "_4w-6";
export var decrementer = "_4w-a";
export var disabled = "_4w-4";
export var error = "_4w-1";
export var hiddenText = "_4w-b";
export var incrementer = "_4w-9";
export var input = "_4w-8";
export var inputWrapper = "_4w-0";
export var leadingIcon = "_4w-c";
export var readonly = "_4w-3";
export var regular = "_4w-7";
export var small = "_4w-5";
export var warning = "_4w-2";